var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "calculationForm",
      attrs: {
        model: _vm.model,
        "label-width": "15em",
        "label-position": "left"
      }
    },
    [
      _vm._t("default"),
      _c("BillingYm", {
        attrs: { required: true, mode: _vm.billingYmMode },
        model: {
          value: _vm.billingYm,
          callback: function($$v) {
            _vm.billingYm = $$v
          },
          expression: "billingYm"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }